import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { AnalyticsService } from './analytics.service';
import { PageTrackingService } from './page-tracking.service';
import { AnalyticsConfig } from './analytics.config';
import { environment } from '../../../environments/environment';

export async function initializeAnalytics(): Promise<void> {
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return;
  }

  const analyticsService = inject(AnalyticsService);
  const pageTrackingService = inject(PageTrackingService);

  const config: AnalyticsConfig = {
    segmentWriteKey: environment.analytics.segmentWriteKey,
    amplitudeSessionReplayKey: environment.analytics.amplitudeSessionReplayKey,
    appVersion: environment.analytics.appVersion,
    isTrackingEnabled: environment.analytics.isTrackingEnabled,
    isSessionReplayEnabled: environment.analytics.isSessionReplayEnabled,
  };

  await analyticsService.initialize(config);
  pageTrackingService.initialize();
}
